const isEmpty = value => {
  return value === ''
    ? { isValid: false, errorMessage: `Ce champs est requis` }
    : { isValid: true, errorMessage: void 0 }
}
const validateTimeZone = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  } else {
    isValid = value.includes('Europe')
    errorMessage = !isValid ? `Dashpool n'est disponible que en Europe` : void 0
  }
  return { isValid, errorMessage }
}

const validateCurrency = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  } else {
    isValid = value === 'EUR'
    errorMessage = !isValid
      ? `Dashpool n'utilise que l'Euro pour le moment`
      : void 0
  }
  return { isValid, errorMessage }
}

const validateCountry = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  } else {
    isValid = value === 'FR'
    errorMessage = !isValid ? `Dashpool n'est disponible que en France` : void 0
  }
  return { isValid, errorMessage }
}
const validateCompanyName = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  }
  return { isValid, errorMessage }
}

const validateAdresse = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  }
  return { isValid, errorMessage }
}
const validateCity = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  }
  return { isValid, errorMessage }
}
const validateCp = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  }
  return { isValid, errorMessage }
}

const validatePhone = (value = '') => {
  let { isValid, errorMessage } = isEmpty(value)
  if (!isValid) {
    return { isValid, errorMessage }
  } else {
    isValid = value.length === 10
    errorMessage = errorMessage = !isValid
      ? `Le numéro doit contenir 10 chiffres`
      : void 0
  }
  return { isValid, errorMessage }
}

export default (name, value) => {
  switch (name) {
    case 'timeZone':
      return validateTimeZone(value)
    case 'currency':
      return validateCurrency(value)
    case 'country':
      return validateCountry(value)
    case 'companyName':
      return validateCompanyName(value)
    case 'adresse':
      return validateAdresse(value)
    case 'cp':
      return validateCp(value)
    case 'phone':
      return validatePhone(value)
    case 'city':
      return validateCity(value)
    default:
      return isEmpty(value)
  }
}



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/GeneralInformations/ValidationHelpers.js